import React, { useEffect, useState } from 'react'
import BetButtons from './betButtons/BetButtons'
import { helperClearStake } from './helpers/helperClearStakeOnLongPress'
import { useUpdateHistory } from './helpers/updateHistory'
import { FOOTER_PROPS } from './interface'
import Positions from './positions/PositionsWrapper'
import ChipSwiper from './swiper/Swiper'
import Text from './text/Text'
import { formatThousandWithDecimals, heplerChip } from './helpers/helperChip'
import { helperUndo } from './helpers/helperUndo'

function Footer({
  gameInfo,
  footerVariables,
  footerHandlers,
  stakesForSocket,
  dealed,
}: FOOTER_PROPS) {
  const {
    currency,
    precision,
    state,
    winType,
    raise,
    turn,
    river,
    totalWin,
    isFold,
    audio,
  } = footerVariables
  const {
    handleNotification,
    texasSocketMessages,
    handleFoldAndDealOut,
    handleDealOut,
  } = footerHandlers

  const [anteStake, setanteStake] = useState<string>(
    formatThousandWithDecimals(stakesForSocket.ante) || '0',
  )
  const [raiseStake, setRaiseStake] = useState<string>(raise.bet || '0')
  const [turnStake, setTurnStake] = useState<string>('0')
  const [riverStake, setRiverStake] = useState<string>('0')
  const [anteHistory, setanteHistory] = useState<string[]>(['0'])

  useEffect(() => {
    setanteStake(formatThousandWithDecimals(stakesForSocket.ante) || '0')
  }, [stakesForSocket])

  useEffect(() => {
    setRaiseStake(formatThousandWithDecimals(raise.bet))
  }, [raise.bet])

  useEffect(() => {
    setTurnStake(formatThousandWithDecimals(turn?.bet))
  }, [turn?.bet])

  useEffect(() => {
    setRiverStake(formatThousandWithDecimals(river?.bet))
  }, [river?.bet])

  const handleChip = (c: string) =>
    heplerChip(
      c,
      setanteStake,
      handleNotification,
      currency,
      gameInfo.maxBet,
      gameInfo.precision,
    )

  useUpdateHistory(anteStake, setanteHistory)

  const handleUndo = () =>
    helperUndo(
      true,
      setanteStake,
      anteHistory,
      setanteHistory,
      clearStakes,
      handleDealOut,
    )
  const helperClearBoard = () => {
    clearStakes()
    handleDealOut()
  }
  const handleClearStake = () => helperClearStake(setanteStake, setanteHistory)

  const [isDealing, setisDealing] = useState(false)
  // todo
  useEffect(() => {
    if (dealed) {
      setisDealing(false)
    }
  }, [dealed])

  const clearStakes = () => {
    setRaiseStake('0')
    setTurnStake('0')
    setRiverStake('0')
  }
  return (
    <>
      <Text
        ante={anteStake}
        state={state}
        playerWinType={winType}
        currency={currency}
        totalWin={totalWin}
        isFold={isFold}
        precision={precision}
      />
      <Positions
        positionHolderVariables={{
          anteStake,
          raiseStake,
          turnStake,
          riverStake,
        }}
      />
      <ChipSwiper
        gameInfo={gameInfo}
        handleChip={handleChip}
        helperClearBoard={helperClearBoard}
        gameState={state}
        state={state === 4 || state === 14 || state === 15 || isDealing}
        audio={audio}
      />
      <BetButtons
        betButtonVariables={{ anteStake, state, currency, precision, audio }}
        betButtonHandlers={{
          texasSocketMessages,
          handleUndo,
          handleClearStake,
          handleFoldAndDealOut,
          handleDealOut,
          clearStakes,
        }}
        dealed={dealed}
        isDealing={isDealing}
        setisDealing={setisDealing}
      />
    </>
  )
}

export default Footer
